import { useState, useEffect } from 'react';

const Footer = () => {
  const [visible, setVisible] = useState(true);
  const [lastY, setLastY] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setVisible(y <= lastY || y < 40);
      setLastY(y);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastY]);

  return (
    <div
      className="fixed bottom-5 left-0 right-0 flex justify-center pointer-events-none transition-opacity duration-300"
      style={{ opacity: visible ? 1 : 0 }}
    >
      <a
        href="https://platform.productos.dev/agents"
        target="_blank"
        rel="noopener noreferrer"
        className="pointer-events-auto inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-[11px] font-medium transition-all duration-200 select-none group"
        style={{
          background: 'rgba(255,255,255,0.85)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          border: '1px solid rgba(203,213,225,0.5)',
          boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
        }}
      >
        <span className="text-[#94A3B8] group-hover:text-[#64748B] transition-colors">Powered by</span>
        <span className="font-semibold text-[#475569] group-hover:text-[#2563EB] transition-colors">ProductOS Agents</span>
      </a>
    </div>
  );
};

export default Footer;
